import { Box, Button, Stack, Typography } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EyewitnessReport from "../../drawer/report";
import PetitionReport from "../../drawer/petition";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import UnverifiedModalContent from "../../../components/unverified-modal";
import useResponsive from "../../../hooks/useResponsive";

export const PostButton = () => {
  const isSmall = useResponsive("down", "sm", "xl");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [open_report_modal, setOpen_report_modal] = React.useState(false);
  const [open_petition_modal, setOpen_petition_modal] = React.useState(false);
  const account_profile = useSelector((state: RootState) => state.content.account_profile_data);

  const toggle_report_drawer = (newOpen: boolean) => () => {
    setOpen_report_modal(newOpen);
  };

  const toggle_petition_drawer = (newOpen: boolean) => () => {
    setOpen_petition_modal(newOpen);
  };
  const open = Boolean(anchorEl);
  const handle_click = (event: React.MouseEvent<HTMLElement>) => {
    if (account_profile?.name) {
      setAnchorEl(event.currentTarget);
    } else {
      handle_modal();
    }
  };
  const handle_close = () => {
    setAnchorEl(null);
  };
  const [open_modal, setOpen_modal] = React.useState(false);
  const handle_modal = () => setOpen_modal(!open_modal);

  const close_petition_drawer = () => setOpen_petition_modal(false);
  const close_report_drawer = () => setOpen_report_modal(false);
  return (
    <>
      <UnverifiedModalContent open={open_modal} handle_modal={handle_modal} />
      <EyewitnessReport
        open_report_modal={open_report_modal}
        toggle_report_drawer={toggle_report_drawer}
        close_report_modal={close_report_drawer}
      />

      <PetitionReport
        open_modal={open_petition_modal}
        toggle_drawer={toggle_petition_drawer}
        close_petition_modal={close_petition_drawer}
      />
      <Box
        sx={{
          height: 70,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          ml: 4,
        }}
      >
        <Button
          variant="contained"
          endIcon={<ArrowDropDownIcon />}
          startIcon={<AddBoxOutlinedIcon />}
          onClick={handle_click}
          sx={{
            borderRadius: "30px",
            boxShadow: "none",
            fontWeight: 400,
            fontSize: "12px",
            width: isSmall ? 80 : 150,
          }}
        >
          {isSmall ? "" : "Create post"}
        </Button>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handle_close}
        onClick={handle_close}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 80,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={toggle_report_drawer(true)}>
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <img
              src="/assets/icons/posts/post-eye.png"
              alt=""
              width={20}
              height={18}
            />
            <Typography
              variant="subtitle2"
              sx={{ color: "#9C9AA5", fontWeight: 400 }}
            >
              Create Eyewitness Report
            </Typography>
          </Stack>
        </MenuItem>
        <MenuItem onClick={toggle_petition_drawer(true)}>
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <img
              src="/assets/icons/posts/post-edit.png"
              alt=""
              width={20}
              height={18}
            />
            <Typography
              variant="subtitle2"
              sx={{ color: "#9C9AA5", fontWeight: 400 }}
            >
              Write a Petition
            </Typography>
          </Stack>
        </MenuItem>
      </Menu>
    </>
  );
};
